import React, { useEffect } from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import Button from '../../../../components/ui/Button';

const SuccessConfirmation = ({ onRedirect, redirectDelay = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onRedirect();
    }, redirectDelay);

    return () => clearTimeout(timer);
  }, [onRedirect, redirectDelay]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-success-50 to-primary-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-soft p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-success-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-success-600" />
            </div>
            <h1 className="text-2xl font-heading font-bold text-accent-800 mb-2">
              Password Updated Successfully!
            </h1>
            <p className="text-accent-600 text-sm">
              Your password has been successfully updated. You can now log in with your new password.
            </p>
          </div>

          <div className="space-y-4">
            <Button
              onClick={onRedirect}
              variant="primary"
              size="lg"
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
            >
              Continue to Login
            </Button>

            <div className="text-center">
              <p className="text-xs text-accent-500">
                Redirecting automatically in {redirectDelay / 1000} seconds...
              </p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-success-50 rounded-lg border border-success-200">
            <div className="flex items-center justify-center text-success-700">
              <CheckCircle size={16} className="mr-2" />
              <span className="text-sm font-medium">Secure & Protected</span>
            </div>
            <p className="text-xs text-success-600 mt-1">
              Your account is now secured with your new password
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessConfirmation;